module.exports = "/work-site/img/enter.ed6068a3.png";